<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.notifications.header.heading')" :has-period-picker="false" :has-pig-type-picker="false">
        <Notifications></Notifications>
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import Notifications from '@/views/dashboard/notifications/notificationsIndex/Notifications.vue';

export default defineComponent({
    components: { DashboardContentLayout, Notifications },
});
</script>
